import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import Button from '../../../components/base/Button';
import { Star, Clock, Users, MapPin, Heart, CheckCircle } from 'lucide-react';

const desertActivities = [
  {
    id: 1,
    title: "Safari dans le Désert Premium",
    location: "Désert Al Madam",
    price: "55.66",
    originalPrice: "75.00",
    duration: "6 heures",
    groupSize: "Jusqu'à 8 personnes",
    rating: 4.9,
    reviews: 2847,
    image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/safari-dubai-desert-.jpg.webp",
    badge: "Bestseller",
    highlights: ["Dîner bédouin", "Spectacle de danse", "Balade en chameau", "Photos professionnelles"],
    description: "Vivez une expérience authentique dans le désert de Dubaï avec notre safari premium. Randonnée en 4x4 dans les dunes, dîner traditionnel bédouin sous les étoiles, et spectacles de danse du ventre."
  }
];

export default function DesertActivitiesPage() {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-6 pb-8 bg-gradient-to-r from-amber-600 to-orange-600 text-white relative">
        <div className="absolute inset-0 bg-[url('https://mesvacancesadubai.com/wp-content/uploads/2020/12/safari-dubai-desert-.jpg.webp')] bg-cover bg-center opacity-30"></div>
        <div className="max-w-7xl mx-auto px-4 relative z-10">
          <h1 className="text-4xl lg:text-5xl font-bold mb-2">Safari dans le Désert</h1>
          <p className="text-lg text-amber-50 max-w-2xl">Découvrez la magie du désert arabique avec nos safaris authentiques</p>
        </div>
      </section>

      {/* Activities */}
      <section className="py-12 flex-grow">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {desertActivities.map((activity) => (
              <div key={activity.id} className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group">
                <div className="relative overflow-hidden">
                  <img
                    src={activity.image}
                    alt={activity.title}
                    className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-amber-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                      {activity.badge}
                    </span>
                  </div>
                  <div className="absolute bottom-4 right-4 bg-white/95 backdrop-blur-sm rounded-lg px-3 py-2">
                    <div className="text-right">
                      <div className="text-lg font-bold text-amber-600">€{activity.price}</div>
                      <div className="text-sm text-gray-500 line-through">€{activity.originalPrice}</div>
                    </div>
                  </div>
                </div>

                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center space-x-1">
                      <Star className="text-amber-400 fill-current" size={16} />
                      <span className="font-semibold text-gray-900">{activity.rating}</span>
                      <span className="text-gray-500 text-sm">({activity.reviews} avis)</span>
                    </div>
                    <div className="flex items-center text-gray-500 text-sm">
                      <MapPin size={14} className="mr-1" />
                      {activity.location}
                    </div>
                  </div>

                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-amber-600 transition-colors">
                    {activity.title}
                  </h3>

                  <p className="text-gray-600 text-sm mb-4">{activity.description}</p>

                  <div className="flex items-center justify-between text-sm text-gray-600 mb-4">
                    <div className="flex items-center">
                      <Clock size={14} className="mr-1" />
                      {activity.duration}
                    </div>
                    <div className="flex items-center">
                      <Users size={14} className="mr-1" />
                      {activity.groupSize}
                    </div>
                  </div>

                  <div className="mb-6">
                    <div className="flex flex-wrap gap-1">
                      {activity.highlights.map((highlight, index) => (
                        <span key={index} className="bg-amber-50 text-amber-700 px-2 py-1 rounded text-xs">
                          <CheckCircle size={12} className="inline mr-1" />
                          {highlight}
                        </span>
                      ))}
                    </div>
                  </div>

                  <Button className="w-full text-sm py-2">
                    Réserver maintenant
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

